// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock4-space1-J2HKx {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock4-space2-kySh0 {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock4-space3-C_OBg {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock4-space4-iwZ15 {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock4-space5-DW_tG {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock4-space6-Kwj2e {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock4-space7-yKDtN {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock4-space8-CmaEl {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock4-spaceTop1-zh73S {
	margin-top: 6px !important;
}

.WhyHostFormBlock4-spaceTop2-eKd5W {
	margin-top: 12px !important;
}

.WhyHostFormBlock4-spaceTop3-ismmu {
	margin-top: 18px !important;
}

.WhyHostFormBlock4-spaceTop4-yq7xT {
	margin-top: 24px !important;
}

.WhyHostFormBlock4-spaceTop5-lFljP {
	margin-top: 30px !important;
}

.WhyHostFormBlock4-spaceTop6-Ser7H {
	margin-top: 36px !important;
}

.WhyHostFormBlock4-spaceTop7-_m1nm {
	margin-top: 42px !important;
}

.WhyHostFormBlock4-spaceTop8-BCFBW {
	margin-top: 48px !important;
}

.WhyHostFormBlock4-noMargin-FrYHo {
	margin: 0px !important;
}

.WhyHostFormBlock4-padding1-u0TQT {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock4-padding2-LKyaL {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock4-padding3-eRMfv {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock4-padding4-QoOFQ {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock4-padding5-E9dbl {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock4-padding6-GoEIB {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock4-padding7-WW2Tk {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock4-paddingTop1-zmFMr {
	padding-top: 6px !important;
}

.WhyHostFormBlock4-paddingTop2-uNWbv {
	padding-top: 12px !important;
}

.WhyHostFormBlock4-paddingTop3-Klzah {
	padding-top: 18px !important;
}

.WhyHostFormBlock4-paddingTop4-DCJz3 {
	padding-top: 24px !important;
}

.WhyHostFormBlock4-paddingTop5-HwG23 {
	padding-top: 30px !important;
}

.WhyHostFormBlock4-paddingTop6-W11Kv {
	padding-top: 36px !important;
}

.WhyHostFormBlock4-paddingTop7-YjQTi {
	padding-top: 42px !important;
}

.WhyHostFormBlock4-noPadding-BEEzk {
	padding: 0px !important;
}

.WhyHostFormBlock4-spaceMarginBottom0-uPPU6 {
	margin-bottom: 0;
}

.WhyHostFormBlock4-textBold-Ti0Ff {
	font-weight: 500 !important;
}

.WhyHostFormBlock4-textBolder-mHC29 {
	font-weight: 700 !important;
}

.WhyHostFormBlock4-textNormal-BvSlb {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostFormBlock4-textDarkBlue-f2NYe {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock4-textLightBlue-Zme7f {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock4-textLightSandleGreen-nzshy {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock4-textLightBrown-sKXuu {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock4-textMediumMaroon-CNney {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock4-textBrown-EV51X {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock4-textMaroon-PCGlN {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock4-textDarkBrown-Ftrzf {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock4-textMediumBrown-TpnHB {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock4-textSkyBlue-MQnOJ {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock4-textGray-tvEza {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock4-errorMessage-jBH3t {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostFormBlock4-userText-cTl4T {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostFormBlock4-panelHeader-v4csy {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostFormBlock4-exportSection-A9slT {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostFormBlock4-exportSectionGridSub-SV_Br {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock4-exportText-sTH3V {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostFormBlock4-exportLinkImg-JwA2p {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostFormBlock4-exportImg-ViIPd {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock4-linkBtn-EtmsL {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostFormBlock4-table-ZvCoK {
	display: table;
}

.WhyHostFormBlock4-tableRow-poD_7 {
	display: table-row;
}

.WhyHostFormBlock4-tableCell-vKni8 {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock4-formGroup-k3D_e {
	margin-bottom: 6px;
}

.WhyHostFormBlock4-marginTop0-XwGYM {
	margin-top: 0;
}

.WhyHostFormBlock4-marginBottom20-eRCPO {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock4-bannerImageBg-eZv2p {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostFormBlock4-bannerDelete-Y4t_2 {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock4-exportLink-r3OrQ {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock4-seachContent-fs7hl {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostFormBlock4-marginBottom9-Ji6BG {
	margin-bottom: 9px;
}

.WhyHostFormBlock4-spaceTop52-WW1rE {
	margin-top: 52px;
}

.WhyHostFormBlock4-profileViewInner-pIxw7 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostFormBlock4-profileViewMain-acp_I {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostFormBlock4-profileViewlabel-kY_1R {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostFormBlock4-profileViewMainContent-aNCYD {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostFormBlock4-reviewsFormStar-mWoft {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostFormBlock4-reviewsFormStar-mWoft svg {
	cursor: pointer;
}

.WhyHostFormBlock4-addLanguageText-ZvNR8 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostFormBlock4-exportSection-A9slT {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock4-spaceTop52-WW1rE {
		margin-top: 18px;
	}

	.WhyHostFormBlock4-exportText-sTH3V {
		float: none;
		margin-top: 12px;
	}

	.WhyHostFormBlock4-exportSectionGridSub-SV_Br {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostFormBlock4-profileViewlabel-kY_1R {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock4-profileViewMainContent-aNCYD {
		width: 100%;
		text-align: center;
	}

	.WhyHostFormBlock4-panelHeader-v4csy {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostFormBlock4-space1-J2HKx`,
	"space2": `WhyHostFormBlock4-space2-kySh0`,
	"space3": `WhyHostFormBlock4-space3-C_OBg`,
	"space4": `WhyHostFormBlock4-space4-iwZ15`,
	"space5": `WhyHostFormBlock4-space5-DW_tG`,
	"space6": `WhyHostFormBlock4-space6-Kwj2e`,
	"space7": `WhyHostFormBlock4-space7-yKDtN`,
	"space8": `WhyHostFormBlock4-space8-CmaEl`,
	"spaceTop1": `WhyHostFormBlock4-spaceTop1-zh73S`,
	"spaceTop2": `WhyHostFormBlock4-spaceTop2-eKd5W`,
	"spaceTop3": `WhyHostFormBlock4-spaceTop3-ismmu`,
	"spaceTop4": `WhyHostFormBlock4-spaceTop4-yq7xT`,
	"spaceTop5": `WhyHostFormBlock4-spaceTop5-lFljP`,
	"spaceTop6": `WhyHostFormBlock4-spaceTop6-Ser7H`,
	"spaceTop7": `WhyHostFormBlock4-spaceTop7-_m1nm`,
	"spaceTop8": `WhyHostFormBlock4-spaceTop8-BCFBW`,
	"noMargin": `WhyHostFormBlock4-noMargin-FrYHo`,
	"padding1": `WhyHostFormBlock4-padding1-u0TQT`,
	"padding2": `WhyHostFormBlock4-padding2-LKyaL`,
	"padding3": `WhyHostFormBlock4-padding3-eRMfv`,
	"padding4": `WhyHostFormBlock4-padding4-QoOFQ`,
	"padding5": `WhyHostFormBlock4-padding5-E9dbl`,
	"padding6": `WhyHostFormBlock4-padding6-GoEIB`,
	"padding7": `WhyHostFormBlock4-padding7-WW2Tk`,
	"paddingTop1": `WhyHostFormBlock4-paddingTop1-zmFMr`,
	"paddingTop2": `WhyHostFormBlock4-paddingTop2-uNWbv`,
	"paddingTop3": `WhyHostFormBlock4-paddingTop3-Klzah`,
	"paddingTop4": `WhyHostFormBlock4-paddingTop4-DCJz3`,
	"paddingTop5": `WhyHostFormBlock4-paddingTop5-HwG23`,
	"paddingTop6": `WhyHostFormBlock4-paddingTop6-W11Kv`,
	"paddingTop7": `WhyHostFormBlock4-paddingTop7-YjQTi`,
	"noPadding": `WhyHostFormBlock4-noPadding-BEEzk`,
	"spaceMarginBottom0": `WhyHostFormBlock4-spaceMarginBottom0-uPPU6`,
	"textBold": `WhyHostFormBlock4-textBold-Ti0Ff`,
	"textBolder": `WhyHostFormBlock4-textBolder-mHC29`,
	"textNormal": `WhyHostFormBlock4-textNormal-BvSlb`,
	"textDarkBlue": `WhyHostFormBlock4-textDarkBlue-f2NYe`,
	"textLightBlue": `WhyHostFormBlock4-textLightBlue-Zme7f`,
	"textLightSandleGreen": `WhyHostFormBlock4-textLightSandleGreen-nzshy`,
	"textLightBrown": `WhyHostFormBlock4-textLightBrown-sKXuu`,
	"textMediumMaroon": `WhyHostFormBlock4-textMediumMaroon-CNney`,
	"textBrown": `WhyHostFormBlock4-textBrown-EV51X`,
	"textMaroon": `WhyHostFormBlock4-textMaroon-PCGlN`,
	"textDarkBrown": `WhyHostFormBlock4-textDarkBrown-Ftrzf`,
	"textMediumBrown": `WhyHostFormBlock4-textMediumBrown-TpnHB`,
	"textSkyBlue": `WhyHostFormBlock4-textSkyBlue-MQnOJ`,
	"textGray": `WhyHostFormBlock4-textGray-tvEza`,
	"errorMessage": `WhyHostFormBlock4-errorMessage-jBH3t`,
	"userText": `WhyHostFormBlock4-userText-cTl4T`,
	"panelHeader": `WhyHostFormBlock4-panelHeader-v4csy`,
	"exportSection": `WhyHostFormBlock4-exportSection-A9slT`,
	"exportSectionGridSub": `WhyHostFormBlock4-exportSectionGridSub-SV_Br`,
	"exportText": `WhyHostFormBlock4-exportText-sTH3V`,
	"exportLinkImg": `WhyHostFormBlock4-exportLinkImg-JwA2p`,
	"exportImg": `WhyHostFormBlock4-exportImg-ViIPd`,
	"linkBtn": `WhyHostFormBlock4-linkBtn-EtmsL`,
	"table": `WhyHostFormBlock4-table-ZvCoK`,
	"tableRow": `WhyHostFormBlock4-tableRow-poD_7`,
	"tableCell": `WhyHostFormBlock4-tableCell-vKni8`,
	"formGroup": `WhyHostFormBlock4-formGroup-k3D_e`,
	"marginTop0": `WhyHostFormBlock4-marginTop0-XwGYM`,
	"marginBottom20": `WhyHostFormBlock4-marginBottom20-eRCPO`,
	"bannerImageBg": `WhyHostFormBlock4-bannerImageBg-eZv2p`,
	"bannerDelete": `WhyHostFormBlock4-bannerDelete-Y4t_2`,
	"exportLink": `WhyHostFormBlock4-exportLink-r3OrQ`,
	"seachContent": `WhyHostFormBlock4-seachContent-fs7hl`,
	"marginBottom9": `WhyHostFormBlock4-marginBottom9-Ji6BG`,
	"spaceTop52": `WhyHostFormBlock4-spaceTop52-WW1rE`,
	"profileViewInner": `WhyHostFormBlock4-profileViewInner-pIxw7`,
	"profileViewMain": `WhyHostFormBlock4-profileViewMain-acp_I`,
	"profileViewlabel": `WhyHostFormBlock4-profileViewlabel-kY_1R`,
	"profileViewMainContent": `WhyHostFormBlock4-profileViewMainContent-aNCYD`,
	"reviewsFormStar": `WhyHostFormBlock4-reviewsFormStar-mWoft`,
	"addLanguageText": `WhyHostFormBlock4-addLanguageText-ZvNR8`
};
module.exports = ___CSS_LOADER_EXPORT___;
